import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { Core2Config } from '../../shared/core2Config';
import {BiReportQueryRunOutputFileHdrModel} from '../../../../../../models';
import {ApiVisa} from '../../shared';
import {Observable} from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ReportQueryRunOutputFileHdrService extends BaseApiTemplateService<BiReportQueryRunOutputFileHdrModel> {
  readonly url =
    Core2Config.DOMAIN_URL +
    Core2Config.TENANT_DOMAIN_URL_PREFIX +
    'bi-reports/query-run-output-file-hdrs/backoffice-ep';

  constructor(theHttp: HttpClient) {
    super();
    this.apiUrl =
      Core2Config.DOMAIN_URL +
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      'bi-reports/query-run-output-file-hdrs/backoffice-ep';
    this.endpoint_path =
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      'bi-reports/query-run-output-file-hdrs/backoffice-ep';
    this.httpClient = theHttp;
  }

  getFile(guid: string, visa: ApiVisa): Observable<Blob> {
    let url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX +
      'bi-reports/query-run-output-file-hdrs/export-csv/backoffice-ep/' + guid;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX +
        'bi-reports/query-run-output-file-hdrs/export-csv/backoffice-ep/' + guid;
    }

    return this.httpClient.get<Blob>(url, this.getHttpHeaderBlob(visa));
  }
}
